import { render } from "./SloganCircle.vue?vue&type=template&id=701d5830&scoped=true"
const script = {}

import "./SloganCircle.vue?vue&type=style&index=0&id=701d5830&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-701d5830"]])

export default __exports__